import { useContext } from 'react';
import AuthContext from '../contexts/AuthContext';

/**
 * @typedef {import('../contexts/AuthContext').AuthContextValue} AuthContextValue
 */

/**
 * Hook to access authentication context
 * @returns {AuthContextValue}
 */
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export default useAuth;
